<script setup lang="ts">
import { useParamStore } from '@/store/param';
import { NCarousel, NCarouselItem } from '@likui628/naive-ui';
import { storeToRefs } from '@repo/stores';
import { useRouter } from 'vue-router';

const props = defineProps<{ carouselList: { thumb: string, uri: string, fileName?:string }[] }>();

const paramStore = useParamStore();
const { scoId } = storeToRefs(paramStore);

const router = useRouter();
const onClick = async (scoId: string) => {
  await router.push(`/project/${scoId}`);
};

// 去掉文件扩展名的函数
const getFileNameWithoutExtension = (fileName?: string) => {
  if (!fileName) return '';
  const lastDotIndex = fileName.lastIndexOf('.');
  return lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;
};

</script>
<template>
  <div class="share-list-container">
    <NCarousel slides-per-view="auto" :space-between="20" :loop="false" draggable>
      <NCarouselItem 
        v-for="(item) in props.carouselList" 
        :key="item.uri" 
        class="carousel-item"
        :class="{ active: item.uri === scoId }"
        @click="onClick(item.uri)"
      >
        <div class="carousel-content">
          <img class="carousel-img" :src="item.thumb" @dragstart.prevent />
          <div class="carousel-caption" v-if="item.fileName">{{ getFileNameWithoutExtension(item.fileName) }}</div>
        </div>
      </NCarouselItem>
    </NCarousel>
  </div>
</template>
<style scoped>
.share-list-container {
  padding: 0px 0px 10px;
}

.carousel-item {
  width: 85px !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  transform: scale(1);
  padding: 4px 2px;
  margin: 0;
  box-sizing: border-box;
  height: 160px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.carousel-item.active {
  transform: scale(1.1);
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.1);
}

.carousel-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding: 4px 0;
}

.carousel-img {
  width: 100%;
  height: 110px;
  object-fit: contain;
  object-position: center center;
  border-radius: 4px;
  display: block;
}

.carousel-caption {
  margin-top: 5px;
  font-size: 11px;
  font-weight: 400;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0,0,0,0.8);
  text-align: center;
  width: 100%;
  line-height: 1.2;
  height: 46px;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
